import { combineReducers } from '@reduxjs/toolkit';
import types from './slice';

export default combineReducers({
  $: types,
});